export const reloadPage = () => {
  const currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set('retry', '1');
  window.location.href = currentUrl.href;
};

export const hasRetried = () => {
  const currentUrl = new URL(window.location.href);
  return currentUrl.searchParams.get('retry') === '1';
};
